module.exports = "/_next/static/media/35f416fd2336baef0d8bf8eb708fc7fe.svg";